import { BaseDialPadButtonContent } from 'features/dial-pad/constants';
import { DialPadButtonValue } from 'features/dial-pad/enums';
import type { DialPadButtonContent } from 'features/dial-pad/interfaces';

export const calculatorDealerButtons: DialPadButtonContent[] = [
  BaseDialPadButtonContent[DialPadButtonValue.Seven],
  BaseDialPadButtonContent[DialPadButtonValue.Eight],
  BaseDialPadButtonContent[DialPadButtonValue.Nine],
  BaseDialPadButtonContent[DialPadButtonValue.Four],
  BaseDialPadButtonContent[DialPadButtonValue.Five],
  BaseDialPadButtonContent[DialPadButtonValue.Six],
  BaseDialPadButtonContent[DialPadButtonValue.One],
  BaseDialPadButtonContent[DialPadButtonValue.Two],
  BaseDialPadButtonContent[DialPadButtonValue.Three],
  BaseDialPadButtonContent[DialPadButtonValue.Zero],
  BaseDialPadButtonContent[DialPadButtonValue.Asterisk],
  BaseDialPadButtonContent[DialPadButtonValue.Hash],
];
